<template>
    <v-container fluid class="d-flex pa-0 fullHeight">
        <v-container fluid class="scrollableContent pa-0">
            <v-container class="container-custom px-6">
                <Breadcrumbs :title="'Títulos'" :description="'Títulos disponibles para descarga.'"></Breadcrumbs>
                <v-row style="justify-content: left">
                    <v-col sm="12" md="6" lg="4" v-for="title in titles" :key="title.id">
                        <v-card v-if="title.status == 2">
                            <v-card-text>
                                <p><span class="body-1 primary--text font-weight-bold text-h8">Nombre: </span>{{ title.studentName }}</p>
                                <p><span class="body-1 primary--text font-weight-bold text-h8">Título: </span>{{ title.academicDegree.degreeDescription }}</p>
                                <p><span class="body-1 primary--text font-weight-bold text-h8">Legajo: </span>{{ title.studentRecordId }}</p>
                                <p><span class="body-1 primary--text font-weight-bold text-h8">Nota: </span>{{ title.grade }}</p>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn small @click="downloadFile(title)" :disabled="loading" :loading="title.id == downloading">
                                    Descargar Título
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { $student } from '../Services';
import { mapGetters } from 'vuex'
import Configuration from '../../../../core/constants/configuration';

export default {
    name: 'StudentTitles',
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            titles: [],
            loading: false,
            downloading: 0,
        }
    },
    mounted() {
        this.initialize();
    },
    computed: {
        ...mapGetters({
            records: 'commons/getStudentRegisters',
        })
    },
    methods: {
        initialize() {
            this.getTitles();
        },
        async getTitles() {
            this.loading = true;
            const studentRecords = this.records;
            for (let i = 0; i < studentRecords.length; i++) {
                const response = await $student.getTitlesBySR(studentRecords[i].legajo);
                this.titles = this.titles.concat(response.data);
            }
            this.loading = false;
		},
        async downloadFile(title) {
            const satisfactionSurveyUrl = Configuration.value('satisfactionSurveyURL')
            const satisfactionSurveyUrlParsed = '<br><a target="_blank" href='.concat(satisfactionSurveyUrl, '>Encuesta de satisfacción</a><br><br>');
            this.loading = true;
            this.downloading = title.id;
            $student.downloadTitle(title.id)
                .then(response => {
                    this.$store.dispatch('commons/openPopUp', {
                        title: '¡Felicidades!',
                        content: [
                         {value: 'Has completado tus estudios. Para mejorar continuamente la calidad de nuestros programas y servicios, te invitamos a participar en una breve encuesta.'},
                         {value: satisfactionSurveyUrlParsed},
                        {value: 'Tus comentarios nos ayudarán a seguir mejorando la experiencia. '}],
                        actionPrimary: {
                            text: 'Descargar',
                            callback() {
                                const fileUrl = response.data;
                                window.open(fileUrl, '_blank');
                            },
                        },
                        actionSecondary:{
                            text: 'Aceptar',
                            callback() {}
                        },
                        icon: { color: 'success', name: 'mdi-check' },
                        color: 'primary',
                    });
                    
                })
                .finally(() => {
                    this.loading = false;
                    this.downloading = 0;
                });
        },
    },
}
</script>
